import { t } from "../tokens-D9z8Q6nJ.js";
const e = '"CarMaxSharpSansDisp-Bold", Helvetica, Arial, sans-serif', i = "Lato, Helvetica, Arial, sans-serif", o = {
  fontFamily: i,
  h1: {
    fontSize: "8.5625rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1
  },
  h2: {
    fontSize: "5.75rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1
  },
  h3: {
    fontSize: "3.8125rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1
  },
  h4: {
    fontSize: "2.5rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1.1
  },
  h5: {
    fontSize: "1.6875rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1.1
  },
  h6: {
    fontSize: "1.125rem",
    fontFamily: e,
    fontWeight: t,
    lineHeight: 1.1
  },
  subtitle1: {
    fontFamily: e,
    fontWeight: t
  },
  subtitle2: {
    fontFamily: e,
    fontWeight: t
  },
  body1: {
    letterSpacing: 0,
    lineHeight: 1.6
  },
  body2: {
    letterSpacing: 0,
    lineHeight: 1.6
  },
  bodyLarge: {
    fontSize: "1.25rem",
    letterSpacing: 0,
    lineHeight: 1.6
  },
  button: {
    fontFamily: e,
    fontSize: "1rem",
    fontWeight: t,
    textTransform: "none"
  }
};
export {
  o as default
};
